import React, {PureComponent}from 'react';
import axios from 'axios';
import  moment from 'moment';
import noImage from './assets/no-img.png'
import 'bootstrap/dist/css/bootstrap.min.css';
import './providerStyle.css';


class ProviderList extends PureComponent {
	 
	constructor() {
		super();
		this.state = {
			providerListState:[],
			showListProvider: true,
			showProviderBookingSlot: false,
			providerDetails:{},
			listOfSlots:[],
			weeklyScheduleSolts:[],
			selectedDayId:"",
			selectedSlotId:"",
			sucessMsg:"",
			errorMsg:"",
			//header:{headers: {'Content-Type': 'application/json','AccessToken': "163038842742107743a01d4314736a21efad433a60bdd"}},//Worksite
			header:{headers: {'Content-Type': 'application/json','AccessToken': "162998106222718c4e41373664cb6a48863115706cabc"}},//Test
			headerApi:{headers: {'Content-Type': 'application/json','Authorization': "Basic be69a016-151e-11ec-82a8-0242ac130003"}},//Worksite
			//companyId:"6115f04a1131cd68d013ee93",//Worksite,
			companyId:"5a687382734d1d7c67982eee",//test
			bookingCnfrmDiv:false,
			baseURL:"https://app.pacifyr.net/pacifyr/v1/",
			selectedDate:"",
			selectedTime:"",
			loadWeeklySch:false,
			ldShProviderDetails:false,
			showListOfSlotsInDay:false,
			showLoadingApBtn:false
		};
	}
	async getListOfPRoviders(){
		var _api = this.state.baseURL+  "admin/pacifyrs?companyId="+this.state.companyId;
		var _responseData = await axios.get(_api, this.state.header);
		this.setState({
			providerListState:_responseData.data
		})
	}
	async getProviderDetails(){
		this.setState({
			ldShProviderDetails:true
		})
		var _api =  this.state.baseURL+  "user/profile/"+this.state.providerId
		var _responseData = await axios.get(_api, this.state.header);
		await this.setState({
			providerDetails:_responseData.data,
			ldShProviderDetails:false
		})
		this.getWeeklySchedule(0);

	}
	async getWeeklySchedule(wekkNumber){
		this.setState({
			loadWeeklySch: true,
			weeklyScheduleSolts:[]
		})
		var _api = this.state.baseURL+  "schedule/byWeek?pacifyrId="+this.state.providerId+"&weekNumber="+wekkNumber;//+this.state.providerId//5a21481e3b105d2bff80d176
		var _responseData = await axios.get(_api, this.state.header);
		await this.setState({
			weeklyScheduleSolts:_responseData.data
		})
		if(wekkNumber === 0){
			var _dayName = moment().format('dddd');
			var _indx = this.state.weeklyScheduleSolts.findIndex((e1)=> e1.day === _dayName)
			await this.setState({
				selectedDayId:this.state.weeklyScheduleSolts[_indx].id,
				selectedDate:this.state.weeklyScheduleSolts[_indx].date,
			})
		}else{
			await this.setState({
				selectedDayId:this.state.weeklyScheduleSolts[0].id,
				selectedDate:this.state.weeklyScheduleSolts[0].date,
			})
		}
		this.setState({
			loadWeeklySch: false
		})
		this.showListOfSlotsInDay();
		
	}
	async fnShPdBookingSlot(id){
		await this.setState({
			showProviderBookingSlot: true,
			showListProvider:false,
			bookingCnfrmDiv:false,
			providerId:id
		})
		this.getProviderDetails();
	}
	async selectedDay(dayId,date){
		await this.setState({
			selectedDayId:dayId,
			selectedDate:date,
			sucessMsg:"",
			errorMsg:""
		})
		this.showListOfSlotsInDay();
	}
	async showListOfSlotsInDay(){
		this.setState({
			shLdingSlotsList:true
		})
	
		var _api = this.state.baseURL+  "schedule/slots/"+this.state.selectedDayId;
		var _responseData = await axios.get(_api, this.state.header);
		this.setState({
			listOfSlots:_responseData.data,
			shLdingSlotsList:false
		})
	}
	async selectSlotsToBook(sotId,time){
		this.setState({
			selectedSlotId:sotId,
			selectedTime:time
		})
	}
	async submitSelectedSlot(){
		if(this.state.selectedSlotId.length != 0 && !this.state.showLoadingApBtn){
			this.setState({
				showLoadingApBtn:true
			})
			var _userRegApi = this.state.baseURL+  "integration/register/client";
			var _userRegPost = {firstName:"Magesh",lastName:"Murugesan",email:"magesh@ceino.com",phoneNumber:"+919952207931"}
			var _userResData = await axios.post(_userRegApi, _userRegPost,this.state.headerApi);
	
			console.log(_userResData);
			/* var _api = this.state.baseURL+  "schedule/slots/book";
			var _postArray = [this.state.selectedSlotId];
			var _postObject = {	userId:"599c40b63b105d08dbb523fc",timeSlotId :_postArray,bookingRequestPaymentId :"5ef387e4afdb75327ce746d4"}

			var _responseData = await axios.post(_api, _postObject,this.state.header);
			console.log(_responseData);
			if(_responseData.data.status === "success"){
				await this.setState({
					sucessMsg:_responseData.data.message,
					errorMsg:"",
				})
			}else{
				await this.setState({					
					sucessMsg:"",
					errorMsg:_responseData.data.message
				})
			}
			await this.setState({
				showProviderBookingSlot: false,
				showListProvider:false,
				bookingCnfrmDiv:true,
				sucessMsg:_responseData.data.message,
				errorMsg:"",
				selectedSlotId:"",
				showLoadingApBtn:false
			}) */
		}
		
	}
	async backToProviderList(){
		await this.setState({
			showProviderBookingSlot: false,
			showListProvider:true,
			providerDetails:{},
			listOfSlots:[],
			weeklyScheduleSolts:[],
			bookingCnfrmDiv:false,
			selectedSlotId:""
		})
	}
	async closeAppointment(){
		this.backToProviderList();
	}
	componentDidMount() {
		 this.getListOfPRoviders();
	}
	render() {
		return(
		<div className="row">
			<div className="col-sm-1 col-md-1"></div>
			{(this.state.showListProvider)?(
				<div className="col-sm-10 col-md-10">
					{/* <h1>Providers</h1> */}
					{this.state.providerListState.map((providerData, i) =>
						(
							<div className="providerbox">
								<div className="providerimg" style={{width:"10%"}}><img src={providerData.image?("http://pacifyrprod.storage.googleapis.com/"+providerData.image):noImage} /></div>
								<div className="providerdtls" style={{width:"70%"}}>
									<h2 style={{marginTop:"5px"}}>{providerData.firstName} {providerData.lastName}</h2>
									<p style={{margin: "0px"}}>{providerData.specialities?providerData.specialities.join(","):"-"}</p>
								</div>
								<div className="bookappntment" onClick={()=>this.fnShPdBookingSlot(providerData.id)} style={{width:"18%"}}>Book an appointment</div>
								{/* <div className="bookappntment bknRate" >Fee : ${providerData.price}</div> */}
								<div style={{clear:"both"}}></div>
							</div>
						)
					)}
					{(this.state.providerListState.length === 0)?(<div className="providerbox"> No provider found</div>):(null)}
				</div>
			):(null)}
			{(this.state.showProviderBookingSlot)?(
				<div className="col-sm-10 col-md-10">
					<span className="backtolist" onClick={()=>this.backToProviderList()} ><img src={require('./assets/month-leftarrow.png').default}/>Back to list</span>
					{(this.state.ldShProviderDetails)?(<div className="loading"></div>):(null)}
					{(!this.state.ldShProviderDetails)?(
						<div className="row userbox">
							<div className="row bookbackBtn">
								<div className="usrimglft col-md-2 col-sm-2">
									<img src={this.state.providerDetails.image?("http://pacifyrprod.storage.googleapis.com/"+this.state.providerDetails.image):noImage} className="usrimglftimg" />
								</div>
								<div className="usrdetlsrght col-md-10 col-sm-10">
									<span className="usrname">{this.state.providerDetails.firstName} {this.state.providerDetails.lastName}</span>
									<span className="usreviews">{this.state.providerDetails.specialities?this.state.providerDetails.specialities.join(","):"-"}</span>
									<span className="usrdescrptn">{this.state.providerDetails.description}</span>
								</div>
								<div style={{"clear":"both"}}></div>
							</div>
							<div style={{/* width:"60%", */padding: "20px 10px"}}>
								<div style={{marginBottom:"15px"}}>
									<span className="seletdtehdng">Select date</span>
									<div style={{float:"right"}}>
										<span className="leftarwimg"><img onClick={()=>this.getWeeklySchedule(0)} src={require('./assets/month-leftarrow.png').default}/></span>
										<span className="datetext" style={{paddingTop:"2px"}}>{moment().format("MMM YYYY") }</span>
										<span className="rghtarwimg"><img src={require('./assets/month-rightarrow.png').default} onClick={()=>this.getWeeklySchedule(1)}/></span>
										<div style={{clear:"both"}}></div>
									</div>
									<div style={{clear:"both"}}></div>
								</div>
								<div className="weekbox">
									<span className="leftarwimg" style={{paddingTop:"15px"}}>< img onClick={()=>this.getWeeklySchedule(0)} src={require('./assets/leftarrow.png').default}/></span>
									{(this.state.loadWeeklySch )?(<div className="loadingDiv"><div className="loading"></div></div>):(null)}
									
									{(this.state.weeklyScheduleSolts).map((soltD,inx)=>(
										((new Date(soltD.date) >= new Date()))?(
											<div className={(this.state.selectedDayId === soltD.id)?"weekpart curentdayactive":"weekpart"} onClick={()=>this.selectedDay(soltD.id, soltD.date)}><span className="weekday">{(soltD.day).substring(0,3)}</span><span className="weekdate">{moment(soltD.date).format("DD") }</span></div>	
										):(
											<div className="weekpart"><span className="weekday">{(soltD.day).substring(0,3)}</span><span className="weekdate">{moment(soltD.date).format("DD") }</span></div>	
										)
									))}
									<span className="rghtarwimg" style={{float:"right",paddingTop:"15px"}}>< img onClick={()=>this.getWeeklySchedule(1)} src={require('./assets/rightarrow.png').default}/></span>
									<div style={{clear:"both"}}></div>
								</div>
							</div>
							<div style={{padding:"20px 10px"}}>
								<span className="seletdtehdng bookCls">Select time</span>
								<div className="row" style={{margin:"0px 0px 20px"}}>
									{(this.state.shLdingSlotsList)?(<div className="loading"></div>):(null)}
									{!this.state.shLdingSlotsList && this.state.listOfSlots.map((solt,indx)=>(
										(solt.booked)?
										(<div className="intervlbox" style={{backgroundColor:"#ffe3db"}}>{solt.startTime} - {solt.endTime}<span style={{color:"red", marginLeft:"2px",fontSize:"10px"}}>(Booked)</span></div>):
										(<div className={ (solt.id === this.state.selectedSlotId)?"intervlbox active_intervlbox":"intervlbox"} onClick={()=>this.selectSlotsToBook(solt.id, solt.startTime)}>{solt.startTime} - {solt.endTime}</div>)
									))}
									<div style={{clear:"both"}}></div>
								</div>
							
							</div>
							{(this.state.selectedSlotId).length !== 0?(
								<div style={{padding:"20px 10px",display: "inline-block",width: "20%"}}>
									<span className="bookanappntmnt" style={{width:"100%"}} onClick={()=>this.submitSelectedSlot()}>Confirm</span>							
								</div>
							):(null)}
							{(this.state.showLoadingApBtn )?(<div className="loading" style={{display: "inline-block",marginLeft: "4px"}}></div>):(null)}
									
							
						</div>
					):(null)}
				</div>
			):(null)}
			{(this.state.bookingCnfrmDiv)?(
				<div className="col-sm-10 col-md-10">
					<span className="backtolist" onClick={()=>this.backToProviderList()} ><img src={require('./assets/month-leftarrow.png').default}/>Back</span>
					<div className="userbox">
						<div className="bookbackBtn">
							<div className="usrimglft" style={{textAlign: "center",marginBottom:"20px"}}>
								<img src={this.state.providerDetails.image?("http://pacifyrprod.storage.googleapis.com/"+this.state.providerDetails.image):noImage} className="usrimglftimg" />
							</div>
							{(this.state.sucessMsg.length != 0 )?(
								<div style={{textAlign: "center",marginBottom:"20px"}}>
									<span className="usrdescrptn" style={{fontSize:"16px",fontWeight:"bold"}}>You appointment is scheduled with {this.state.providerDetails.firstName} {this.state.providerDetails.lastName} </span>
									<span className="usrdescrptn" style={{fontSize:"16px",fontWeight:"bold"}}>on {moment(this.state.selectedDate).format("MMM Do YYYY")} at {this.state.selectedTime}</span>
								</div>
							):(null)}
							{(this.state.errorMsg.length != 0)?(
								<div style={{textAlign: "center",marginBottom:"20px"}}>
									<span className="usrdescrptn" style={{fontSize:"16px",fontWeight:"bold"}}>{this.state.errorMsg}</span>
								</div>
							):(null)}
							
							<div  style={{textAlign: "center"}}>
								<span className="bookanappntmnt" onClick={()=>this.closeAppointment()}  style={{width: "10%"}}>Ok</span>
							</div>
							<div style={{"clear":"both"}}></div>
						</div>
					</div>
				</div>
			):(null)}

			
			<div class="col-sm-1 col-md-1"></div>
		</div>
		);
	}
}
  export default ProviderList;